var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"participants-list"}},[_vm._v(" list ")])}
var staticRenderFns = []

export { render, staticRenderFns }